<div class="share-member-permission">
  <sync-dialog
    [config]="{
      title: 'Edit permissions',
      subTitle: name,
      isClosable: true,
      closeIcon:'arrow-left',
      onCloseIcon: onBack,
      actionButton: 'Save',
      onActionClick: onSave,
      cancelButton: 'Cancel',
      onCancelClick: onBack,
      isButtonLoading: spinner,
    }"
    [open]="showDialog"
    [isFullScreen]="isSmallScreen"
  >
    <div class="share-member-permission-container">
      <div class="body-1">Editing permissions for <span class="body-bold">{{email}}</span>.</div>
      <sync-divider [text]="'Content'" [size]="'default'"></sync-divider>
      <div class="permission-box">
        <div class="permission-container">
            <!-- <p *ngIf="!isPro"> Can view and edit <a class="syncblue" routerLink="/account/upgrade" (click)="close()">Upgrade your account</a> to set read only permissions.</p> -->
            <div class="permission">
              <div>
                <sync-checkbox
                  [label]="'Can view'"
                  [checked]="true"
                  [indeterminate]="false"
                  [disabled]="true"
                ></sync-checkbox>
              </div>
      
              <div>
                <sync-checkbox
                  [onChange]="onCheckCanEditChange"
                  [label]="'Can edit'"
                  [checked]="!!sharemember.permissions.perUPLOAD"
                  [indeterminate]="false"
                  [disabled]="isPro === 0"
                ></sync-checkbox>
              </div>
            </div>
      
            <div class="permission">
              <div>
                <sync-checkbox
                  [onChange]="onCheckCanInviteChange"
                  [label]="'Can invite'"
                  [checked]="!!sharemember.permissions.perINVITE"
                  [indeterminate]="false"
                ></sync-checkbox>
              </div>
              <div>
                <sync-checkbox
                  [onChange]="onCheckCanSeeOthersChange"
                  [label]="'See others'"
                  [checked]="!!sharemember.permissions.perSEEOTHERS"
                  [indeterminate]="false"
                ></sync-checkbox>
              </div>
            </div>
          </div>
      </div>
    </div>
  </sync-dialog>
</div>
